import classNames from 'classnames'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {SummaryRowProps} from './interfaces'
import {classes} from './summary-row.st.css'

export const SummaryRow = ({label, value, dataHook, size = 'regular'}: SummaryRowProps) =>
  value ? (
    <div className={classNames(classes.row, {[classes.large]: size === 'regular'})} data-hook={dataHook}>
      <Text>{label}</Text>
      <Text>{value}</Text>
    </div>
  ) : null
